// A reasonable default model implementation
// for select
export class SelectModel {
  /**
   * @param {object} items - Object of key value pairs containing the select values and display text 
   */
  constructor(items) {
    this._items = [];

    for (const key of Object.keys(items)) {
      this._items.push({
        value: key,
        text: items[key],
        props: {
          disabled: false,
        }
      });
    }
  }

  get items() {
    return this._items;
  }

  setProperty(value, propkey, propValue) {
    this.items.forEach((item) => {
      if (item['value'] === value) {
        item['props'][propkey] = propValue;
      }
    });
  }

  resetProperties() {
    this.items.forEach((item) => {
      item.props.disabled = false;
    });
  }
}


// WEBPACK FOOTER //
// ./client/app/shared/form/select.model.js